/* 화면 글자 바꾸기(9/28) — 사장님 「뺄수있는건 전부 빼고 심사받자 … 심사는 받으면서 해야 빠르게 진행되지」.
   서버 파일 app/data/text.json 의 「바꾸기」 표 { "원래 글": "새 글" } 로 화면의 글자(단추 · 안내 문구 · 제목 등)를 바꾼다.
   그 파일만 고쳐 올리면 웹과 토스판에 바로 반영된다(번들 심사 없음). 받는 것은 글뿐이고 코드는 받지 않는다.
   · 글자 칸 하나의 글 전체가 표의 「원래 글」과 똑같을 때만 바꾼다(앞뒤 빈칸은 무시). 풀이 글 · 이름처럼 다른 글은 건드리지 않는다.
     이름이 끼어 만들어지는 글(예: 「○○의 풀이를 쓰고 있어요」)은 인물마다 따로 적어야 바뀐다.
   · placeholder · aria-label · title · alt 속성도 같은 방식으로 바꾼다(글 · 속성 모두 이 파일이 넣은 값은 다시 바꾸지 않는다 — 10/1).
   · 화면이 새로 그려지면(MutationObserver) 그때도 바꾼다. 표가 비었거나 못 받으면 아무것도 하지 않는다(지켜보기도 켜지 않는다). */
(() => {
  const ATTRS = ["placeholder", "aria-label", "title", "alt"];
  const has = (o, k) => Object.prototype.hasOwnProperty.call(o, k);
  let MAP = null;
  const mine = new WeakMap();   // 이 파일이 바꿔 넣은 글 — 그 글을 다시 바꾸지 않는다(표가 서로 물고 도는 일을 막는다)
  function fixText(n) {
    const t = n.nodeValue, p = n.parentNode;
    if (!t || !p || p.nodeName === "SCRIPT" || p.nodeName === "STYLE" || mine.get(n) === t) return;
    const k = t.trim();
    if (!k || !has(MAP, k)) return;
    const out = t.replace(k, String(MAP[k]));
    mine.set(n, out);
    if (out !== t) n.nodeValue = out;
  }
  // 10/1 코드 점검 — 속성도 글처럼 이 파일이 넣은 값은 다시 바꾸지 않는다(요소마다 { 속성: 넣은 값 }).
  //   예전에는 글만 막아서, 서로 바꾸는 짝({"A":"B","B":"A"})이 속성(aria-label · alt · title · placeholder)에 걸리면 바꾸기와 지켜보기가 서로를 끝없이 불러 화면이 멈췄다.
  const mineA = new WeakMap();
  function fixEl(el) {
    let got = mineA.get(el);
    for (const a of ATTRS) {
      const v = el.getAttribute(a); if (!v || (got && got[a] === v)) continue;
      const k = v.trim(); if (!has(MAP, k)) continue;
      const out = String(MAP[k]); if (out === v) continue;
      if (!got) mineA.set(el, (got = {}));
      got[a] = out; el.setAttribute(a, out);
    }
  }
  function walk(root) {
    if (root.nodeType === 3) return fixText(root);
    if (root.nodeType !== 1) return;
    fixEl(root);
    const it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    for (let n = it.nextNode(); n; n = it.nextNode()) { if (n.nodeType === 3) fixText(n); else fixEl(n); }
  }
  function start() {
    walk(document.body);
    new MutationObserver((list) => {
      for (const m of list) {
        if (m.type === "characterData") fixText(m.target);
        else if (m.type === "attributes") fixEl(m.target);
        else m.addedNodes.forEach(walk);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  }
  fetch("/app/data/text.json", { cache: "no-cache" })
    .then((r) => (r.ok ? r.json() : null))
    .then((j) => {
      const map = j && j.바꾸기 && typeof j.바꾸기 === "object" ? j.바꾸기 : null;
      if (!map) return;
      MAP = {};
      for (const [k, v] of Object.entries(map)) if (typeof v === "string" && k.trim()) MAP[k.trim()] = v;
      if (!Object.keys(MAP).length) return;
      if (document.body) start(); else document.addEventListener("DOMContentLoaded", start, { once: true });
    })
    .catch(() => { /* 번들 글 그대로 */ });
})();
